var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.jsonLoaded)?_c('div',[_c('vue-three-sixty',{attrs:{"amount":_vm.seriesImageCount,"image-path":_vm.imagePath,"file-name":_vm.fileName}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }